<template>
  <v-layout row wrap>
    <v-flex xs12 px-2>
      <v-card>
        <v-toolbar flat dense color="primary" dark>
          <v-toolbar-title>
            {{ $tc('titles.notifications.receiver') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="actions" card flat dense color="white">
          <v-text-field
            v-model="match"
            flat
            hide-details
            :placeholder="$t('action.buttons.search')"
            prepend-icon="search"
            solo
          />
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-data-table
            :headers="headers"
            :items="items"
            disable-initial-sort
            :search="match"
            :rows-per-page-items="[5]"
          >
            <template slot="items" slot-scope="props">
              <td>
                <template
                  v-if="
                    typeReceiver === 'entity' ||
                    typeReceiver === 'entityFollowers'
                  "
                >
                  <v-list-tile avatar ripple class="receiver-item">
                    <v-list-tile-avatar>
                      <img :src="props.item.logo" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="props.item.text" />
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <template
                  v-else-if="
                    typeReceiver === 'team' || typeReceiver === 'teamFollowers'
                  "
                >
                  <v-list-tile avatar ripple class="receiver-item">
                    <v-list-tile-avatar>
                      <img :src="props.item.logo" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="props.item.text" />
                      <v-list-tile-sub-title
                        class="caption primary--text text--lighten-1"
                      >
                        {{ props.item.category }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <template
                  v-else-if="
                    typeReceiver === 'user' ||
                    typeReceiver === 'playerFollowers'
                  "
                >
                  <v-list-tile avatar ripple class="receiver-item">
                    <v-list-tile-avatar>
                      <img :src="props.item.photo" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="props.item.text" />
                      <v-list-tile-sub-title
                        v-if="props.item.teams && props.item.teams.length"
                      >
                        <v-chip
                          v-for="team of props.item.teams"
                          :key="team._id"
                          class="my-0"
                          color="transparent"
                        >
                          <v-avatar>
                            <v-img :src="team.logo" />
                          </v-avatar>
                          <v-list-tile-content class="caption">
                            <v-list-tile-title>
                              <span> {{ team.name }}</span>
                            </v-list-tile-title>
                            <v-list-tile-sub-title
                              class="caption primary--text text--lighten-1 text-truncate"
                            >
                              {{ team.categoryName.join(' - ') }}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-chip>
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title
                        v-else-if="
                          props.item.entities && props.item.entities.length
                        "
                      >
                        <v-chip
                          v-for="entity of props.item.entities"
                          :key="entity._id"
                          class="my-0"
                          color="transparent"
                          small
                        >
                          <v-avatar>
                            <v-img :src="entity.logo" />
                          </v-avatar>
                          <span class="caption primary--text text--lighten-1">{{
                            entity.name
                          }}</span>
                        </v-chip>
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title
                        v-else-if="
                          matchId &&
                          teamId &&
                          typeRole.includes('player') &&
                          (props.item.position ||
                            props.item.convocation ||
                            props.item.dorsal)
                        "
                        class="caption primary--text text--lighten-1"
                      >
                        <template v-if="props.item.position">
                          <span>{{ props.item.position }}</span>
                          <span>|</span>
                        </template>
                        <template v-if="props.item.convocation">
                          <span>{{
                            $t(
                              `fields.teams.convocations.${props.item.convocation}`
                            )
                          }}</span>
                          <span>|</span>
                        </template>
                        <span
                          v-if="props.item.dorsal === 0 || props.item.dorsal"
                          >{{
                            `${$t('fields.global.dorsal')}: ${
                              props.item.dorsal
                            }`
                          }}</span
                        >
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <template v-else-if="typeReceiver === 'category'">
                  <v-list-tile ripple class="receiver-item">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ props.item.text }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </td>
              <td v-if="actions" class="text-xs-center px-0">
                <v-icon
                  color="error"
                  @click="$emit('delete', props.item.value)"
                >
                  delete
                </v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ReceiverList',
  props: {
    typeReceiver: {
      type: String,
    },
    items: {
      type: Array,
    },
    actions: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { match: '' }
  },
  computed: {
    headers() {
      const headers = [
        {
          text: this.$t('fields.global.name'),
          sortable: false,
        },

        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
      ]

      return this.actions ? headers : [headers[0]]
    },
  },
}
</script>
<style>
.receiver-item > .v-list__tile--avatar {
  height: auto;
}
</style>
